import { useEffect } from 'react';
import { useGetUserQuery } from '../../services/userApi';

const SUPPORT_SCRIPT_ID = 'rex-support-embed';
const SUPPORT_SCRIPT_SRC = 'https://rex-support-os.vercel.app//embed.js';
const NPS_SCRIPT_ID = 'rex-nps-embed';
const NPS_SCRIPT_SRC = 'https://rex-support-os.vercel.app/nps-embed.js';

declare global {
  interface Window {
    RexSupport?: {
      user: { email: string; name: string; id: string };
    };
  }
}

export default function RexSupportWidget() {
  const { data: user } = useGetUserQuery({});

  useEffect(() => {
    if (!user) return;

    window.RexSupport = {
      user: {
        email: user.email,
        name: `${user.first_name} ${user.last_name}`,
        id: user.id,
      },
    };

    if (!document.getElementById(SUPPORT_SCRIPT_ID)) {
      const script = document.createElement('script');
      script.id = SUPPORT_SCRIPT_ID;
      script.src = SUPPORT_SCRIPT_SRC;
      script.defer = true;
      script.dataset.rexSupportProduct = 'payup';
      document.head.appendChild(script);
    }

    if (!document.getElementById(NPS_SCRIPT_ID)) {
      const script = document.createElement('script');
      script.id = NPS_SCRIPT_ID;
      script.src = NPS_SCRIPT_SRC;
      script.defer = true;
      script.dataset.rexNpsProduct = 'payup';
      document.head.appendChild(script);
    }

    return () => {
      document.getElementById(SUPPORT_SCRIPT_ID)?.remove();
      document.getElementById(NPS_SCRIPT_ID)?.remove();
      delete window.RexSupport;
    };
  }, [user?.id]);

  return null;
}
